/**
 * 统一异常页 + 路由级 ErrorBoundary。
 *
 * 401 由 Transport 拦截重定向登录（不在异常页展示）；403 无权限、500/网络异常可重试，不暴露堆栈。
 * 覆盖 admin-web-shell:SC-12/SC-13/SC-14。
 */
import { Button, Result } from 'antd';

export interface ErrorPageProps {
  /** 错误类型 */
  type: 'forbidden' | 'error' | 'empty';
  /** 可选重试回调 */
  onRetry?: () => void;
}

export function ErrorPage({ type, onRetry }: ErrorPageProps) {
  if (type === 'forbidden') {
    return (
      <Result
        status="403"
        title="无权限"
        subTitle="您没有访问该资源的权限，请联系管理员。"
      />
    );
  }
  if (type === 'empty') {
    return <Result status="info" title="暂无数据" />;
  }
  return (
    <Result
      status="500"
      title="系统异常"
      subTitle="服务暂时不可用，请稍后重试。"
      extra={
        onRetry ? (
          <Button type="primary" onClick={onRetry}>
            重试
          </Button>
        ) : undefined
      }
    />
  );
}
